export const environment = {
  production: true,
  url : "https://admin.3boltcourt.com/api/public/",
  base : "https://3boltcourt.com/admin/documents/",
  root : "https://admin.3boltcourt.com/"
  // url : "http://phantompro.co.uk/chambers/api/public/",
  // base : "http://phantompro.co.uk/chambers/documents/",
  // root : "http://phantompro.co.uk/chambers/"
};
